import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { updateDeliveryChallan } from "../../../../../Store/prosafe/proTransaction/Challan/updateDeliveryChallan";
import { createDeliveryChallan } from "../../../../../Store/prosafe/proTransaction/Challan/createDeliveryChallan";
import {
    getOneDeliveryChallan,
    resetGetOneDeliveryChallan
} from "../../../../../Store/prosafe/proTransaction/Challan/getOneDeliveryChallan";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Swal from "sweetalert2";
import { Country, State, City } from "country-state-city";
import ItemDetails from "./components/ItemDetails";
import TermsAndTaxSummary from "./components/TermsAndTaxSummary";
import ChallanDetails from "./components/ChallanDetails";

const initialState = {
    date: moment().format("YYYY-MM-DD"),
    description: "",
    project_id: "",
    project_no: "",
    items_details: [],
    total_amount: 0,
    total_quantity: 0,
    terms_and_cond: "",
    bill_to: {
        name: "",
        address: "",
        addressOne: "",
        city: "Surat",
        state: "Gujarat",
        pincode: "",
        gst_no: "",
    },
    ship_to: {
        name: "",
        address: "",
        addressOne: "",
        city: "Surat",
        state: "Gujarat",
        pincode: "",
        gst_no: "",
    },
    transportation_details: {
        date: moment().format("YYYY-MM-DD"),
        doc_no: "",
        delivery_terms: "",
        dispatch_through: "",
        other_ref: "",
    },
    bank_details: {
        name: "HDFC Bank",
        account_no: "50200012345678",
        ifsc: "HDFC0001234",
        acc_holder_name: "BEPL Pvt Ltd"
    },
    delivery_by: {
        name: "",
        comment: "",
        date: moment().format("YYYY-MM-DD"),
    },
    received_by: {
        name: "",
        comment: "",
        date: moment().format("YYYY-MM-DD"),
    },
};

const initialItemState = {
    name: "",
    hsn: "",
    qty: "",
    unit: "",
    weight: "",
    rate: "",
    amount: 0,
};

const ManageDeliveryChallan = () => {
    const { state: locationData } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const indiaCountry = Country.getAllCountries().find(
        (country) => country.name === "India"
    );
    const indiaCode = indiaCountry?.isoCode || "IN";

    const [stateList, setStateList] = useState([]);
    const [stateList2, setStateList2] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [cityList2, setCityList2] = useState([]);

    const [deliveryChallanData, setDeliveryChallanData] = useState(initialState);
    const [items, setItems] = useState([{ ...initialItemState }]);
    const [error, setError] = useState({});
    const [itemErrors, setItemErrors] = useState([{}]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [taxSummary, setTaxSummary] = useState({
        subtotal: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxAmount: 0,
        roundOff: 0,
        total: 0,
    });
    const [canAddMoreItems, setCanAddMoreItems] = useState(false);

    const editData = useSelector((state) => state?.getOneDeliveryChallan?.user?.data);
    const { loading: addLoading } = useSelector((state) => state?.addDeliveryChallan);
    const { loading: updateLoading } = useSelector(
        (state) => state?.updateDeliveryChallan
    );
    const isLoading = addLoading || updateLoading;

    useEffect(() => {
        if (indiaCode) {
            setStateList(State.getStatesOfCountry(indiaCode));
            setStateList2(State.getStatesOfCountry(indiaCode));
        }
    }, [indiaCode]);

    useEffect(() => {
        if (deliveryChallanData.bill_to.state && indiaCode) {
            const selectedStateCode = State.getStatesOfCountry(indiaCode).find(
                (st) => st.name === deliveryChallanData.bill_to.state
            )?.isoCode;

            if (selectedStateCode) {
                setCityList(City.getCitiesOfState(indiaCode, selectedStateCode));
            }
        }
    }, [deliveryChallanData.bill_to.state, indiaCode]);

    useEffect(() => {
        if (deliveryChallanData.ship_to.state && indiaCode) {
            const selectedStateCode2 = State.getStatesOfCountry(indiaCode).find(
                (st) => st.name === deliveryChallanData.ship_to.state
            )?.isoCode;

            if (selectedStateCode2) {
                setCityList2(City.getCitiesOfState(indiaCode, selectedStateCode2));
            }
        }
    }, [deliveryChallanData.ship_to.state, indiaCode]);

    useEffect(() => {
        if (locationData?._id) {
            dispatch(getOneDeliveryChallan(locationData._id));
        } else {
            dispatch(resetGetOneDeliveryChallan());
            setDeliveryChallanData(initialState);
            setItems([{ ...initialItemState }]);
            setItemErrors([{}]);
        }
    }, [dispatch, locationData]);

    useEffect(() => {
        return () => {
            dispatch(resetGetOneDeliveryChallan());
        };
    }, [dispatch]);

    useEffect(() => {
        if (!locationData?._id || !editData) return;

        setDeliveryChallanData({
            ...initialState,
            ...editData,
            project_no: editData.manual_project_no,
            project_id: editData.projectDetails?._id,
            date: moment(editData.date).format("YYYY-MM-DD"),
            bill_to: {
                ...initialState.bill_to,
                ...editData.bill_to,
            },
            ship_to: {
                ...initialState.ship_to,
                ...editData.ship_to,
            },
            transportation_details: {
                ...initialState.transportation_details,
                ...editData.transportation_details,
            },
            bank_details: {
                ...initialState.bank_details,
                ...editData.bank_details,
            },
            delivery_by: {
                ...initialState.delivery_by,
                ...editData.delivery_by,
                date: moment(editData.delivery_by.date).format("YYYY-MM-DD"),
            },
            received_by: {
                ...initialState.received_by,
                ...editData.received_by,
                date: moment(editData.received_by.date).format("YYYY-MM-DD"),
            },
        });

        if (editData.items_details?.length) {
            setItems(editData.items_details.map((item) => ({ ...item, unit: item.unit._id })));
            setItemErrors(editData.items_details.map(() => ({})));
        }
    }, [editData]);

    useEffect(() => {
        const currentItem = items[items.length - 1];
        const isValid =
            currentItem?.name?.trim() 
            // currentItem?.qty &&
            // parseFloat(currentItem.qty) > 0 &&
            // currentItem?.rate &&
            // parseFloat(currentItem.rate) > 0;
        setCanAddMoreItems(isValid);
    }, [items]);

    // Calculate tax based on firm and party state
    const calculateTaxType = () => {

        // const firmState = firmData
        //     ?.find((f) => f._id === firm_id)
        //     ?.state?.toLowerCase()
        //     ?.trim();
        // const partyState = deliveryChallanData.estimate_party_data.state
        //     ?.toLowerCase()
        //     ?.trim();

        // If states match, use CGST+SGST, otherwise use IGST
        // return firmState && partyState && firmState === partyState
        //     ? "cgst_sgst"
        //     : "igst";

        return "igst";
    };

    // Calculate all totals and taxes
    useEffect(() => {
        const subtotal = items.reduce(
            (sum, item) => sum + (parseFloat(item.amount) || 0),
            0
        );
        const totalQty = items.reduce(
            (sum, item) => sum + (parseFloat(item.qty) || 0),
            0
        );

        const taxType = calculateTaxType();
        const taxRate = 0.18; // 18% tax
        const taxAmount = subtotal * taxRate;

        let cgst = 0,
            sgst = 0,
            igst = 0;

        if (taxType === "cgst_sgst") {
            cgst = taxAmount / 2;
            sgst = taxAmount / 2;
        } else {
            igst = taxAmount;
        }

        const totalBeforeRound = subtotal + taxAmount;
        const roundOff = Math.round(totalBeforeRound) - totalBeforeRound;
        const total = Math.round(totalBeforeRound);

        setTaxSummary({
            subtotal,
            cgst,
            sgst,
            igst,
            taxAmount,
            roundOff,
            total,
        });

        setDeliveryChallanData((prev) => ({
            ...prev,
            total_amount: total,
            total_quantity: totalQty,
        }));
    }, [
        items,
        // deliveryChallanData.estimate_party_data.state,
    ]);

    // Validate individual item
    const validateItem = (index) => {
        const item = items[index];
        const errors = {};

        if (!item.name || !item.name.trim()) {
            errors.name = "Item name is required";
        }
        if (!item.unit || !item.unit.trim()) {
            errors.unit = "Unit is required";
        }
        // if (!item.qty || parseFloat(item.qty) <= 0) {
        //     errors.qty = "Valid quantity is required";
        // }
        // if (!item.rate || parseFloat(item.rate) <= 0) {
        //     errors.rate = "Valid rate is required";
        // }


        const updatedItemErrors = [...itemErrors];
        updatedItemErrors[index] = errors;
        setItemErrors(updatedItemErrors);

        return Object.keys(errors).length === 0;
    };

    const handleItemChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index][field] = value;

        if (field === "qty" || field === "rate") {
            const quantity = parseFloat(updatedItems[index].qty) || 0;
            const rate = parseFloat(updatedItems[index].rate) || 0;
            updatedItems[index].amount = (quantity * rate).toFixed(2);
        }

        setItems(updatedItems);

        const updatedItemErrors = [...itemErrors];
        if (updatedItemErrors[index] && updatedItemErrors[index][field]) {
            delete updatedItemErrors[index][field];
            setItemErrors(updatedItemErrors);
        }
    };

    const handleItemBlur = (index, field) => {
        if (field === "name" || field === "qty" || field === "rate") {
            validateItem(index);
        }
    };

    const handleAddItem = () => {
        const lastItem = items[items.length - 1];

        if (
            !lastItem.name?.trim() 
            // || !lastItem.qty || !lastItem.rate
        ) {
            toast.error(
                "Please complete current item details before adding new item"
            );
            return;
        }

        // if (parseFloat(lastItem.qty) <= 0 || parseFloat(lastItem.rate) <= 0) {
        //     toast.error("Please enter valid quantity and rate for current item");
        //     return;
        // }

        setItems([...items, { ...initialItemState }]);
        setItemErrors([...itemErrors, {}]);
        toast.success("New item row added");
    };

    // Remove item row with SweetAlert confirmation
    const handleRemoveItem = (index, name) => {
        if (items.length === 1) {
            toast.error("At least one item is required");
            return;
        }

        Swal.fire({
            title: `${name}`,
            text: `Do you want to delete this item?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                const updatedItems = items.filter((_, i) => i !== index);
                const updatedItemErrors = itemErrors.filter((_, i) => i !== index);
                setItems(updatedItems);
                setItemErrors(updatedItemErrors);

                Swal.fire({
                    title: "Deleted!",
                    text: "Item has been deleted.",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        });
    };

    // Handle form field changes
    const handleChange = (section, field, value) => {
        if (section) {
            setDeliveryChallanData((prev) => ({
                ...prev,
                [section]: {
                    ...prev[section],
                    [field]: value,
                },
            }));
        } else {
            setDeliveryChallanData((prev) => ({
                ...prev,
                [field]: value,
            }));
        }

        // Clear error for this field
        if (error[field] || error[`party_${field}`]) {
            setError(prev => ({
                ...prev,
                [section]: {
                    ...prev[section],
                    [field]: undefined
                }
            }));
        }
    };

    const validateForm = () => {
        const errors = {};
        errors.bill_to = {};
        errors.ship_to = {};
        errors.transportation_details = {};

        if (!deliveryChallanData.date) errors.date = "Date is required";
        if (!deliveryChallanData.project_id) errors.project_id = "Project is required";

        // bill to
        // if (!deliveryChallanData.bill_to.name) errors.bill_to.name = "Name is required";
        if (!deliveryChallanData.bill_to.address) errors.bill_to.address = "Address is required";
        if (!deliveryChallanData.bill_to.city) errors.bill_to.city = "City is required";
        if (!deliveryChallanData.bill_to.state) errors.bill_to.state = "State is required";
        if (!deliveryChallanData.bill_to.pincode) errors.bill_to.pincode = "Pincode is required";

        // ship to
        // if (!deliveryChallanData.ship_to.name) errors.ship_to.name = "Name is required";
        if (!deliveryChallanData.ship_to.address) errors.ship_to.address = "Address is required";
        if (!deliveryChallanData.ship_to.city) errors.ship_to.city = "City is required";
        if (!deliveryChallanData.ship_to.state) errors.ship_to.state = "State is required";
        if (!deliveryChallanData.ship_to.pincode) errors.ship_to.pincode = "Pincode is required";

        // transportation details 
        if (!deliveryChallanData.transportation_details.date)
            errors.transportation_details.date = "Date is required";
        if (!deliveryChallanData.transportation_details.delivery_terms)
            errors.transportation_details.delivery_terms = "Delivery Terms is required";
        if (!deliveryChallanData.transportation_details.doc_no)
            errors.transportation_details.doc_no = "Doc No is required";

        // Validate all items
        let hasItemErrors = false;
        const newItemErrors = items.map((item, index) => {
            const itemError = {};
            if (!item.name || item.name.trim() === "") {
                itemError.name = "Item Name Required";
                hasItemErrors = true;
            }
            if (!item.unit || item.unit.trim() === "") {
                itemError.unit = "Unit Required";
                hasItemErrors = true;
            }
            // if (!item.qty || parseFloat(item.qty) <= 0) {
            //     itemError.qty = "Quantity Required";
            //     hasItemErrors = true;
            // }
            // if (!item.rate || parseFloat(item.rate) <= 0) {
            //     itemError.rate = "Rate Required";
            //     hasItemErrors = true;
            // }
            return itemError;
        });

        if (hasItemErrors) {
            errors.items = "Please fill all required item fields";
            setItemErrors(newItemErrors);
        }


        if (Object.keys(errors.bill_to).length === 0)
            delete errors.bill_to;

        if (Object.keys(errors.ship_to).length === 0)
            delete errors.ship_to;

        if (Object.keys(errors.transportation_details).length === 0)
            delete errors.transportation_details;

        setError(errors);
        return Object.keys(errors).length === 0;

    };

    const handleSubmit = () => {
        if (!validateForm()) {
            toast.error("Please fill all required fields");
            return;
        }

        const firm_id = localStorage.getItem("PAY_USER_FIRM_ID");
        const year_id = localStorage.getItem("PAY_USER_YEAR_ID");

        const payload = {
            firm_id: firm_id,
            year_id: year_id,
            date: deliveryChallanData.date,
            project_id: deliveryChallanData.project_id,
            manual_project_no: deliveryChallanData.project_no,
            description: deliveryChallanData.description,
            terms_and_cond: deliveryChallanData.terms_and_cond,
            items_details: items,
            bill_to: deliveryChallanData.bill_to,
            ship_to: deliveryChallanData.ship_to,
            transportation_details: deliveryChallanData.transportation_details,
            bank_details: deliveryChallanData.bank_details,
            received_by: deliveryChallanData.received_by,
            delivery_by: deliveryChallanData.delivery_by,
        };

        if (locationData?._id) {
            dispatch(updateDeliveryChallan({ id: locationData?._id, payload: payload }))
                .then((response) => {
                    const { success, message } = response?.payload;
                    if (success) {
                        toast.success(message);
                        navigate("/main-store/user/delivery-challan-management");
                    }
                });
        } else {
            dispatch(createDeliveryChallan(payload))
                .then((response) => {
                    const { success, message } = response?.payload;
                    if (success) {
                        toast.success(message);
                        navigate("/main-store/user/delivery-challan-management");
                    }
                });
        }
    };

    const handleReset = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "All form data will be cleared!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, reset it!",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                setDeliveryChallanData(initialState);
                setItems([{ ...initialItemState }]);
                setError({});
                setItemErrors([{}]);
                toast.success("Form has been reset");
            }
        });
    };

    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const taxType = calculateTaxType();

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/main-store/user/dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/main-store/user/delivery-challan-management">Delivery Challan List</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        {locationData?._id ? "Edit" : "Add"} Delivery Challan
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* Header Section */}
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-heading mb-4">
                                                <h4 className="mb-0">
                                                    {locationData?._id ? "Edit" : "Add"} Delivery Challan Details
                                                </h4>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Firm Selection & Date */}
                                    <ChallanDetails
                                        challanData={deliveryChallanData}
                                        error={error}
                                        handleChange={handleChange}
                                        indiaCode={indiaCode}
                                        cityList={cityList}
                                        stateList={stateList}
                                        cityList2={cityList2}
                                        stateList2={stateList2}
                                    />

                                    {/* Items Section */}
                                    <ItemDetails
                                        items={items}
                                        itemErrors={itemErrors}
                                        handleItemChange={handleItemChange}
                                        handleItemBlur={handleItemBlur}
                                        handleAddItem={handleAddItem}
                                        handleRemoveItem={handleRemoveItem}
                                        canAddMoreItems={canAddMoreItems}
                                        isLoading={isLoading}
                                        error={error}
                                    />

                                    {/* Tax Summary Section */}
                                    <TermsAndTaxSummary
                                        challanData={deliveryChallanData}
                                        handleChange={handleChange}
                                        taxSummary={taxSummary}
                                        taxType={taxType}
                                    />

                                    {/* Submit Buttons */}
                                    <div className="row mt-4">
                                        <div className="col-12">
                                            <div className="doctor-submit text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary submit-form me-2"
                                                    onClick={handleSubmit}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <span
                                                                className="spinner-border spinner-border-sm me-2"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            Processing...
                                                        </>
                                                    ) : (
                                                        <>{locationData?._id ? "Update" : "Submit"}</>
                                                    )}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary cancel-form me-2"
                                                    onClick={handleReset}
                                                    disabled={isLoading}
                                                >
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageDeliveryChallan;
